import React from 'react';
import './Careers.css';

const jobOpenings = [
  {
    title: 'Frontend Developer (React)',
    type: 'Full-Time',
    location: 'Remote',
    description: 'Work with our UI/UX team to bring designs to life using modern React-based architecture.',
  },
  {
    title: 'Backend Developer (Node.js)',
    type: 'Full-Time',
    location: 'Remote',
    description: 'Help architect and scale APIs, databases, and infrastructure using Node.js, Express, and MongoDB.',
  },
  {
    title: 'AI/ML Engineer',
    type: 'Contract',
    location: 'Remote',
    description: 'Integrate AI tools and models into our client applications using OpenAI, TensorFlow or similar stacks.',
  },
  {
    title: 'UI/UX Designer',
    type: 'Part-Time',
    location: 'Remote',
    description: 'Design intuitive user interfaces and experiences across web and mobile products.',
  },
];

const Careers = () => {
  return (
    <div className="careers-container">
      <div className="careers-hero">
        <h1 className="careers-title">Join the Skript Team</h1>
        <p className="careers-subtitle">
          We're always looking for passionate developers, designers, and creatives to help us build the future of software.
        </p>
      </div>

      <div className="jobs-grid">
        {jobOpenings.map((job, index) => (
          <div className="job-card" key={index}>
            <h3>{job.title}</h3>
            <div className="job-meta">
              <span>{job.type}</span> • <span>{job.location}</span>
            </div>
            <p>{job.description}</p>
            <a
              href="mailto:careers@skriptuae.com?subject=Job Application - [Your Name]"
              target="_blank"
              rel="noopener noreferrer"
              className="apply-button"
            >
              Apply Now
            </a>
          </div>
        ))}
      </div>

      <div className="quote-cta">
        <h2>Don’t See Your Role?</h2>
        <p>We’re always open to unique talent. Send us your profile and ideas — let’s make things happen.</p>
        <a
          href="mailto:careers@skriptuae.com"
          target="_blank"
          rel="noopener noreferrer"
          className="apply-button"
        >
          Send General Application
        </a>
      </div>
    </div>
  );
};

export default Careers;
